export const newsConstants = {

	getNews: {
		REQUEST : "GET_NEWS_REQUEST",
		SUCCESS : "GET_NEWS_SUCCESS",
		FAILURE : "GET_NEWS_FAILURE"
	},
	getOneNews: {
		REQUEST : "GETONE_NEWS_REQUEST",
		SUCCESS : "GETONE_NEWS_SUCCESS",
		FAILURE : "GETONE_NEWS_FAILURE"
	},
	createNews: {
		REQUEST : 'CREATE_NEWS_REQUEST',
		SUCCESS : 'CREATE_NEWS_SUCCESS',
		FAILURE : 'CREATE_NEWS_FAILURE'
	},
	deleteNews: {
		REQUEST : 'DELETE_NEWS_REQUEST',
		SUCCESS : 'DELETE_NEWS_SUCCESS',
		FAILURE : 'DELETE_NEWS_FAILURE'
	},
	changeNews: {
		REQUEST : 'CHANGE_NEWS_REQUEST',
		SUCCESS : 'CHANGE_NEWS_SUCCESS',
		FAILURE : 'CHANGE_NEWS_FAILURE'
	},
	downloadFile: {
		REQUEST : "GET_FILE_REQUEST",
		SUCCESS : "GET_FILE_SUCCESS",
		FAILURE : "GET_FILE_FAILURE"
	},
	restoreNews: {
		REQUEST : "RESTORE_NEWS_REQUEST",
		SUCCESS : "RESTORE_NEWS_SUCCESS",
		FAILURE : "RESTORE_NEWS_FAILURE"
	},
	getAllNews: {
		REQUEST : "GET_ALL_NEWS_REQUEST",
		SUCCESS : "GET_ALL_NEWS_SUCCESS",
		FAILURE : "GET_ALL_NEWS_FAILURE"
	},
	clear: "NEWS_CLEAR"
}